import React from 'react';

export default class Page3 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <table className="ilead_v_sport people_active tablesrink"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="center" width="100%">What do I want to
                                                        achieve from my job?
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">
                                                        <textarea className="textareaborder width-sept"
                                                                  rows="20"
                                                                  name="textarea"
                                                                  value={pageData?.WhatDoIWantToAchieveFromMyJob?.textarea}
                                                                  onChange={this.props.handleChangePageData('WhatDoIWantToAchieveFromMyJob')}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <p>What are the most important tasks to complete to ensure I
                                                meet my job objectives?</p>

                                            <table cellSpacing="0" cellPadding="0" border="0" width="100%"
                                                   className="ilead_v_sport ilead_v_sport_new_task thought_active1 tablesrink sept">
                                                <tbody>
                                                <tr>
                                                    <th valign="top" className="border-pad" width="8%">1
                                                    </th>
                                                    <td align="left" width="92%" className="lgtgreenbg">
                                                        <textarea className="textareaborder width-sept"
                                                                  rows="3"
                                                                  name="1"
                                                                  value={pageData?.WhatAreTheMostImportantTasksToCompleteToEnsure?.[1]}
                                                                  onChange={this.props.handleChangePageData('WhatAreTheMostImportantTasksToCompleteToEnsure')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" width="8%"><strong>2</strong></td>
                                                    <td align="left" width="92%" className="darkgreen">
                                                                   <textarea className="textareaborder width-sept"
                                                                             rows="3"
                                                                             name="2"
                                                                             value={pageData?.WhatAreTheMostImportantTasksToCompleteToEnsure?.[2]}
                                                                             onChange={this.props.handleChangePageData('WhatAreTheMostImportantTasksToCompleteToEnsure')}/>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" width="8%"><strong>3</strong></td>
                                                    <td align="left" width="92%" className="lgtgreenbg">
                                                                  <textarea className="textareaborder width-sept"
                                                                            rows="3"
                                                                            name="3"
                                                                            value={pageData?.WhatAreTheMostImportantTasksToCompleteToEnsure?.[3]}
                                                                            onChange={this.props.handleChangePageData('WhatAreTheMostImportantTasksToCompleteToEnsure')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" width="8%"><strong>4</strong></td>
                                                    <td align="left" width="92%" className="darkgreen">
                                                                  <textarea className="textareaborder width-sept"
                                                                            rows="3"
                                                                            name="4"
                                                                            value={pageData?.WhatAreTheMostImportantTasksToCompleteToEnsure?.[4]}
                                                                            onChange={this.props.handleChangePageData('WhatAreTheMostImportantTasksToCompleteToEnsure')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top" className="border-lft" width="8%">
                                                        <strong>5</strong></td>
                                                    <td align="left" width="92%" className="lgtgreenbg">
                                                                   <textarea className="textareaborder width-sept"
                                                                             rows="3"
                                                                             name="5"
                                                                             value={pageData?.WhatAreTheMostImportantTasksToCompleteToEnsure?.[5]}
                                                                             onChange={this.props.handleChangePageData('WhatAreTheMostImportantTasksToCompleteToEnsure')}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="border_subtitle">Step 2</div>
                                            <p>Once you are clear about what ‘importance’ means to you, you
                                                are ready to prioritise tasks.
                                                Using the table on the next page, list some of the tasks
                                                you’ve been asked to complete in the
                                                last couple of weeks. Then, rate the importance of each on a
                                                scale of 1 to 10, where 10 is
                                                ‘extremely important’.</p>
                                            <p>Next, consider why they are important. We think some tasks
                                                are important just because we do
                                                them automatically – but where do they fit on your scale?
                                                Again, you might need to think again
                                                about what you consider ‘important’.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}